import { Link, useLocation, useNavigate } from "react-router-dom"
import "./Navbar.css"
import Logo from "../../assets/ParanaMap_Oficial.png"
import logoEsteio from '../../assets/esteio_azul_sembg.png';
import logoIat from '../../assets/logo_iat.png';
import { LuLogOut } from "react-icons/lu"
import { Box, Drawer, IconButton } from "@mui/material"
import { IoMenu } from "react-icons/io5"
import { IoClose } from "react-icons/io5"
import { useState, useEffect } from "react"
import { FaMap } from "react-icons/fa6"
import { IoDocumentAttach } from "react-icons/io5"
import { BiSolidReport } from "react-icons/bi";
import { FaUserPlus } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { isUserAdmin, isSimepar } from "../../utils/auth"
import { FaUserLock } from 'react-icons/fa';
import ShpIcon from '../../assets/shapefileIcon.svg';
import { GrValidate } from "react-icons/gr";
import { FaFileExcel } from "react-icons/fa";

export default function Navbar({ onDrawerToggle }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [animateItems, setAnimateItems] = useState(false)

  function logout() {
    localStorage.clear()
    navigate("/")
  }

  const toggleDrawer = () => {
    const newDrawerState = !drawerOpen;
    setDrawerOpen(newDrawerState);

    if (onDrawerToggle) {
      onDrawerToggle(newDrawerState);
    }
  };

  useEffect(() => {
    let timer
    if (drawerOpen) {
      timer = setTimeout(() => {
        setAnimateItems(true)
      }, 100)
    } else {
      setAnimateItems(false)
    }

    return () => clearTimeout(timer)
  }, [drawerOpen])

  const belowNavbarStyle = {
    top: "var(--navbar-height)",
    height: "calc(100% - var(--navbar-height))",
  }

  return (
    <div className="navbar-container">
      <nav className="navbar">
        <div className="navbar-left"
          onClick={() => {
            if (location.pathname === "/Home") {
              window.location.reload();
            } else {
              navigate("/Home");
            }
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src={logoEsteio || "/placeholder.svg"} alt="Esteio Logo" className="esteio-logo-image" />
          <div className="navbar-system-text">
            <span>SISTEMA DE</span>
            <span>GERENCIAMENTO</span>
            <span>DE PROJETOS</span>
          </div>
        </div>

        <div className="navbar-center">
          <div className="navbar-title">CONSÓRCIO PARANAMAP</div>
          <img src={Logo} alt="Paraná Map Logo" className="logo-parana-image" />
        </div>
        <div className="navbar-right">
          <div className="project-label">
            <img src={logoIat} alt="IAT Logo" className="iat-logo-image" />
          </div>
          <IconButton
            onClick={toggleDrawer}
            className={`menu-button ${drawerOpen ? "menu-open" : ""}`}
            aria-label={drawerOpen ? "Fechar menu" : "Abrir menu"}
          >
            <div className="icon-container">
              <IoMenu
                size={30}
                color="#233777"
                className={`menu-icon ${drawerOpen ? "icon-hidden" : "icon-visible"}`}
              />
              <IoClose
                size={30}
                color="#233777"
                className={`close-icon ${drawerOpen ? "icon-visible" : "icon-hidden"}`}
              />
            </div>
          </IconButton>
        </div>
      </nav>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer}
        className="side-drawer"
        transitionDuration={{ enter: 400, exit: 300 }}
        slotProps={{
          backdrop: { // fundo escurecido
            style: belowNavbarStyle,
            className: "custom-backdrop",
          },
          paper: { // painel deslizante
            className: "drawer-paper",
            style: belowNavbarStyle,
          },
        }}
        // ajustar o modal (janela flutuante)
        ModalProps={{
          style: belowNavbarStyle,
        }}
      >
        <Box className="drawer-content" role="presentation">
          <div className="drawer-items">
            <ul className="drawer-links">
              <li
                className={`${location.pathname === "/Home" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                style={{ animationDelay: "0ms" }}
              >
                <Link to="/Home" onClick={toggleDrawer}>
                  <FaMap size={24} />
                  <span>Mapa</span>
                </Link>
              </li>
              <li
                className={`${location.pathname === "/documents" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                style={{ animationDelay: "100ms" }}
              >
                <Link to="/documents" onClick={toggleDrawer}>
                  <IoDocumentAttach size={24} />
                  <span>Documentos</span>
                </Link>
              </li>
              <li
                className={`${location.pathname === "/documents" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                style={{ animationDelay: "100ms" }}
              >
                <Link to="/shapefiles" onClick={toggleDrawer}>
                  <img src={ShpIcon} alt="Shapefile Icon" width={32} height={40} />

                  <span>Shapefiles</span>
                </Link>
              </li>
              {(isUserAdmin() || isSimepar()) && (
                <li
                  className={`${location.pathname === "/product-validation" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to="/product-validation" onClick={toggleDrawer}>
                    <GrValidate  size={24} />
                    <span>Validação de Produto</span>
                  </Link>
                </li>
              )}
              {(isUserAdmin()) && (
                <li
                  className={`${location.pathname === "/review-import" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to="/review-import" onClick={toggleDrawer}>
                    <FaFileExcel size={24} />
                    <span>Importar Pendências</span>
                  </Link>
                </li>
              )}
              {isUserAdmin() && (
                <li
                  className={`${location.pathname === "/upload-shapefile" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to="/upload-shapefile" onClick={toggleDrawer}>
                    <FaLayerGroup size={24} />
                    <span>Atualizar Layer</span>
                  </Link>
                </li>
              )}
              {isUserAdmin() && (
                <li
                  className={`${location.pathname === "/report" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to={"/report"} onClick={toggleDrawer}>
                    <BiSolidReport size={24} />
                    <span>Gerar Relatório</span>
                  </Link>
                </li>
              )}
              {isUserAdmin() && (
                <li
                  className={`${location.pathname === "/user-form" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to={"/user-form"} onClick={toggleDrawer}>
                    <FaUserPlus size={24} />
                    <span>Criar Novo Usuário</span>
                  </Link>
                </li>
              )}
              {isUserAdmin() && (
                <li
                  className={`${location.pathname === "/user-log" ? "active" : ""} ${animateItems ? "animate-item" : ""}`}
                  style={{ animationDelay: "100ms" }}
                >
                  <Link to={"/user-log"} onClick={toggleDrawer}>
                    <FaUserLock size={24} />
                    <span>Log de Acesso</span>
                  </Link>
                </li>
              )}
            </ul>
            <button
              className={`logout-button ${animateItems ? "animate-item" : ""}`}
              onClick={logout}
              style={{ animationDelay: "200ms" }}
            >
              <LuLogOut size={24} />
              <span>Sair</span>
            </button>
          </div>
        </Box>
      </Drawer>
    </div>
  )
}
